import React from 'react';

import TextInput from '../../../TextInput';

const MAX_SIZE_INPUT_TEXT = 255;

const TextAnswer = ({ tempId, selectedValue, onChange }) => (
  <TextInput
    className="w-100"
    limit={MAX_SIZE_INPUT_TEXT}
    type="text"
    name={tempId}
    value={selectedValue}
    onChange={onChange}
  />
);

export default TextAnswer;



// WEBPACK FOOTER //
// ./src/components/SequentialSurvey/Answers/TextAnswer/index.jsx